import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Claim } from '@dataTypes/claimManagement.types'
import {
  fetchAllClaims,
  addClaim,
  updateClaim,
  removeClaim,
} from '../actions/claim.action'

interface ClaimsState {
  data: Claim[]
  loading: boolean
  error: string | null
}

const initialState: ClaimsState = {
  data: [],
  loading: false,
  error: null,
}

const claimSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllClaims.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchAllClaims.fulfilled,
        (state, action: PayloadAction<Claim[]>) => {
          state.data = action.payload
          state.loading = false
        },
      )

      .addCase(fetchAllClaims.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(addClaim.fulfilled, (state, action: PayloadAction<Claim>) => {
        state.data.push(action.payload)
        state.loading = false
      })
      .addCase(addClaim.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(updateClaim.fulfilled, (state, action: PayloadAction<Claim>) => {
        const index = state.data.findIndex(
          (item) => item.id === action.payload.id,
        )
        if (index !== -1) {
          state.data[index] = action.payload
        }
        state.loading = false
      })
      .addCase(updateClaim.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(
        removeClaim.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.data = state.data.filter((claim) => claim.id !== action.payload)
          state.loading = false
        },
      )
      .addCase(removeClaim.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default claimSlice.reducer
